import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { TrialBanner } from '@zafroi/ui-kit';
import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { CommandPaletteProvider } from '@/components/CommandPalette';
import { MAVK_TRIAL } from '@/config/trial';
import { authService } from '@/services/auth';
import { session } from '@/lib/session';
import { ExitToPlatform } from '@/routes/ExitToPlatform';

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  // ADR-013/014: the ERP carries no platform surfaces, and a PLATFORM_ADMIN has
  // no operational ERP nav, so one who lands here is bounced to the platform
  // console. CRITICAL: decide this on a FRESHLY confirmed identity, never the
  // per-origin cached user. localStorage is per-origin and NOT cleared when a
  // different user signs in on another *.zafroi.com app, so the cached user can
  // be a stale PLATFORM_ADMIN from a previous session on this origin — bouncing
  // on it would wrongly eject a legitimate TENANT_ADMIN (and make Operations
  // unreachable for them). We fetch /auth/me on mount and bounce only when the
  // CURRENT session resolves to PLATFORM_ADMIN. Fail-open on error (don't strand).
  const [confirmedPlatformAdmin, setConfirmedPlatformAdmin] = useState(false);
  useEffect(() => {
    let alive = true;
    authService
      .me()
      .then((fresh) => {
        if (!alive) return;
        session.updateUser(fresh);
        if (fresh.tier === 'PLATFORM_ADMIN') setConfirmedPlatformAdmin(true);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  if (confirmedPlatformAdmin) {
    return <ExitToPlatform />;
  }

  return (
    <div className="flex h-screen w-full bg-background">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <div className="flex min-w-0 flex-1 flex-col">
        {/* Platform-wide beta-trial banner — sits above the topbar so it's
            visible on every authenticated page, not buried under
            module-specific chrome. Renders nothing once the trial expires
            (subscriptions / paywall layer takes over from there). */}
        <TrialBanner config={MAVK_TRIAL} />
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1440px] px-5 py-6 md:px-7 md:py-7 lg:px-9 lg:py-8">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPaletteProvider />
    </div>
  );
}
